/**
 * AssetConditionService
 * Service for AssetCondition lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetCondition CRUD operations */
export class AssetConditionService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetConditionService.DEFAULT_SERVICE_PATH,
            basePath: AssetConditionService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetConditionService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetConditionService.BASE_PATH = 'api/asset-conditions';
//# sourceMappingURL=AssetConditionService.js.map